import {inject} from '@angular/core';
import {UrlTree} from '@angular/router';
import {ModalController} from '@ionic/angular';
import {SharedConfirmLeaveModalComponent} from "@shared/components/confirm-leave-modal/shared-confirm-leave-modal.component";
import {TechInventoryMissionPagesService} from "@tech/pages/inventory/pages/mission-detail/services/tech-mission-pages.service";
import {EAssignedUser} from "@tech/pages/inventory/enums/assigned-user.emun";
import {Store} from "@ngrx/store";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {MissionState} from "@server-models";
import {EMissionDetailSegment} from "@tech/pages/inventory/pages/mission-detail/enums/mission-detail-segment.emun";

export const techReportPageCanLeaveGuard: (component: any, router: any, currentState: any,
                                           nextState: any) => (boolean | Promise<boolean | UrlTree>) = (component, router,
                                                                                                  currentState,
                                                                                                  nextState) => {
  const modalCtrl = inject(ModalController);
  const store = inject(Store);
  const techInventoryMissionPagesService = inject(TechInventoryMissionPagesService);

  // in case that is trying to leave because it is a submit
  if (nextState.url.split('/').includes('success')) {
    return true;
  }

  // in case we are seeing a readOnly report version
  if (component?.currentMission?.state === MissionState.Done) {
    return true;
  }

  const canLeave = component?.canLeave ? component.canLeave() : true;
  return canLeave ? true : presentModal(modalCtrl, techInventoryMissionPagesService, store);
};

async function presentModal(modalCtrl: ModalController,
                            techInventoryMissionPagesService: TechInventoryMissionPagesService,
                            store: Store): Promise<boolean> {
  const modal = await modalCtrl.create({
    component: SharedConfirmLeaveModalComponent
  });
  await modal.present();

  const { data } = await modal.onWillDismiss();

  // in case that the navigation is cancel it is needed also update the segment
  if (data?.confirmed === false) {
    techInventoryMissionPagesService.changeSegmentSetting(EMissionDetailSegment.REPORT);
  }

  // to resolve the navigation and set the mission loading to false
  store.dispatch(TechInventoryActions.missionNavigateDone());

  return data?.confirmed ? true : false;
}
